export default "__VITE_ASSET__CxrxvNNw__"